module.exports = __webpack_public_path__ + "static/media/jess_les.63577616.jpg";